import { Component, HostListener, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EmitType } from '@syncfusion/ej2-base';
import { switchMap } from 'rxjs/operators';
import { SyncfusionService } from 'src/app/services/syncfusion.service';

@Component({
  selector: 'app-create-workorder-column-molecule',
  templateUrl: './create-workorder-column-molecule.component.html',
  styleUrls: ['./create-workorder-column-molecule.component.scss']
})
export class CreateWorkorderColumnMoleculeComponent {
  @Input() data: any;
  @Input() header: any;
  @Input() reportName: any;
  @Input() workOrderData: { [sku: string]: string } = {};
  @Input() updateGrid!: (material: string, field: string, value: any) => void;
  verifyToEnableIconColor: { id: string } = { id: '' };
  bomDialogVisible: boolean;
  selected_bomdata: any;
  createWODialogVisible: boolean;
  dialogVisible: boolean = false;
  createWorkOrdersFromUser: {
    materialCode: string;
    locationCode: string;
    qty: number;
    fulfilledQty?: string;
  };
  getConfigDataForSpecificRow: { pendingQty: any; piCreatedToday: number; piToBeCreated: number; };
  bulkWorkOrdersPayload: any[] = [];
  bulkWorkOrdersPayloadCount: number = 0;
  parentObj: any = {};
  excessWorkOrderDetails: { [sku: string]: number } = {};
  excessWorkOrderKeys: string[] = [];
  skuList: any[] = [];
  skuListHeaders: any[] = [];
  skuTableFetched: boolean = false;
  selectedDataObject: any = {};
  poCode = new FormControl('', Validators.required);
  deliveryDate = new FormControl(null, [Validators.required, this.dateValidator]);
  selectedIndex: any;
  loadParentGrid: boolean = false;

  constructor(private syncfusion: SyncfusionService, private snack: MatSnackBar) { }

  ngOnInit() {
    this.skuListHeaders = [
      {
        "field": "sku",
        "headerText": "EAN Code",
        "allowFiltering": false,
        "width": "180",
      },
      {
        "field": "size",
        "headerText": "Size",
        "allowFiltering": false,
        "width": "160",
      },
      {
        "field": "suggested_wo",
        "headerText": "Suggested Work Order",
        "allowFiltering": false,
        "width": "160",
      },
      {
        "field": "createWorkOrder",
        "headerText": "Create Work Order",
        "allowFiltering": false,
        "width": "160"
      },
      {
        "field": "colour",
        "headerText": "Colour",
        "allowFiltering": false,
        "width": "160"
      },
    ];
    if (this.header && this.data) {
      const suggestedWorkOrderTextBox = this.reportName.includes('Brandstudio_Replenishment')
        ? this.data['suggested_wo'] : this.data['piToBeCreated'] - this.data['piCreatedToday'];
      this.data['userWorkOrders'] =
        suggestedWorkOrderTextBox > 0 ? suggestedWorkOrderTextBox : 0;
      this.workOrderData[this.data.sku] = suggestedWorkOrderTextBox > 0 ? suggestedWorkOrderTextBox : 0;
      return this.data;
    } else if (this.data && this.data.result) {
      const suggestedWorkOrderTextBox = this.reportName.includes('Brandstudio_Replenishment')
        ? this.data.suggested_wo : this.data.piToBeCreated - this.data.piCreatedToday;
      this.data.userWorkOrders =
        suggestedWorkOrderTextBox > 0 ? suggestedWorkOrderTextBox : 0;
      return this.data;
    }
    // if (this.reportName === 'Brandstudio_Replenishment_SKU') {
    //   // this.skuListHeaders = [
    //   //   {
    //   //     "field": "sku",
    //   //     "headerText": "Material",
    //   //     "allowFiltering": false,
    //   //     "width": "180",
    //   //   },
    //   //   {
    //   //     "field": "size",
    //   //     "headerText": "Size",
    //   //     "allowFiltering": false,
    //   //     "width": "160",
    //   //   },
    //   //   {
    //   //     "field": "suggested_wo",
    //   //     "headerText": "Suggested Work Order",
    //   //     "allowFiltering": false,
    //   //     "width": "160",
    //   //   },
    //   //   {
    //   //     "field": "createWorkOrder",
    //   //     "headerText": "Create Work Order",
    //   //     "allowFiltering": false,
    //   //     "width": "160"
    //   //   },
    //   //   {
    //   //     "field": "colour",
    //   //     "headerText": "Colour",
    //   //     "allowFiltering": false,
    //   //     "width": "160"
    //   //   },
    //   // ];
    // }
  }
  dateValidator(control: FormControl) {
    const selectedDate = control?.value;
    if (!selectedDate) {
      return { required: true };
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (new Date(selectedDate) < today) {
      return { invalidDate: true };
    }

    return null;
  }
  handleConfirmation(data) {
    this.createWorkOrdersFromUser = {
      materialCode: data.materialCode || data.sku,
      locationCode: data.locationCode || data.location,
      qty: +data.userWorkOrders,
    };
    this.getConfigDataForSpecificRow = {
      pendingQty: data?.pendingQty ?? data?.pending_wo_qty ?? 0,
      piCreatedToday: data.piCreatedToday != null ? +data.piCreatedToday : 0,
      piToBeCreated: data.piToBeCreated != null ? +data.piToBeCreated : +data.suggested_wo
    }
    // const noNeedPopUP = data.piToBeCreated >= +(Number(data.piCreatedToday) + Number(data.userWorkOrders));
    const noNeedPopUP = data.piToBeCreated !== undefined ? data.piToBeCreated >= +(Number(data.piCreatedToday) + Number(data.userWorkOrders))
      : data.suggested_wo >= +Number(data.userWorkOrders);
    if (noNeedPopUP) {
      if (data.userWorkOrders > 0) {
        this.verifyToEnableIconColor.id = data.materialCode || data.sku;
        this.handleCreateWorkOrders()
        setTimeout(() => {
          this.verifyToEnableIconColor.id = "";
        }, 1000);
      }
    }
    else {
      if (data.userWorkOrders > 0) {
        this.dialogVisible = true;
      }
    }

  }
  handleCreateWorkOrders() {
    this.syncfusion.createWorkOrders(this.createWorkOrdersFromUser).subscribe(
      (res) => {
        const material = this.createWorkOrdersFromUser.materialCode;
        const pendingQty = +this.createWorkOrdersFromUser.qty + this.getConfigDataForSpecificRow.pendingQty;
        const piCreatedToday = +this.createWorkOrdersFromUser.qty + this.getConfigDataForSpecificRow.piCreatedToday;
        const suggestedWorkOrderTextBox = this.getConfigDataForSpecificRow.piToBeCreated - piCreatedToday;
        const userWorkOrders = suggestedWorkOrderTextBox > 0 ? suggestedWorkOrderTextBox : 0;
        const normalizedData = Array.isArray(this.data) ? this.data : this.data?.result || [];
        normalizedData.map((m: any, index: number) => {
          if (m.materialCode === this.createWorkOrdersFromUser.materialCode || m.sku === this.createWorkOrdersFromUser.materialCode) {
            m.userWorkOrders = userWorkOrders;
          }
          return m;
        })

        this.data.piCreatedToday = piCreatedToday;
        this.data.userWorkOrders = userWorkOrders;

        this.updateGridValue(material, 'piCreatedToday', piCreatedToday);
        this.updateGridValue(material, 'pendingQty', pendingQty);

        // this.grid.setCellValue(material, 'piCreatedToday', piCreatedToday);
        // this.grid.setCellValue(material, 'pendingQty', pendingQty);
        // this.grid.setCellValue(material, 'createWorkOrder', userWorkOrders);

        const message = `Created Successfully`;
        this.snack.open(message, "close", {
          duration: 4000,
          horizontalPosition: "center",
          verticalPosition: "top",
        });
      },
      (error) => {
        const message = `${error.error.error}`;
        this.snack.open(message, "close", {
          duration: 4000,
          horizontalPosition: "center",
          verticalPosition: "top",
        });
      },
      () => {
        delete this.createWorkOrdersFromUser;
      }
    );
    this.dialogVisible = false;
  }
  updateGridValue(material: string, label: any, value: any) {
    if (material) {
      this.updateGrid(material, label, value);
    }
  }


  @HostListener("document:keydown.escape", ["$event"])
  handleEscKey(event: KeyboardEvent) {
    if (this.dialogVisible) {
      this.dialogVisible = false;
    }
    if (this.bomDialogVisible) {
      this.bomDialogVisible = false;
    }
    if (this.createWODialogVisible) {
      this.createWODialogVisible = false;
    }
  }
  public onOverlayClick: EmitType<object> = () => {
    this.bomDialogVisible = false;
    this.createWorkOrdersFromUser ? delete this.createWorkOrdersFromUser : '';
    if (this.dialogVisible) {
      this.dialogVisible = false;
      return;
    }
    if (this.createWODialogVisible) {
      if (this.loadParentGrid) {
        // this.reloadPageEvent.emit();
        // this.syncfusion.setReload(false);
        this.loadParentGrid = false;
        this.handleParentGridData()
      }
      this.createWODialogVisible = false;
      this.selectedDataObject = {};
      this.poCode.setValue(null);
      this.deliveryDate.setValue(null);
    }
  };
  handleParentGridData() {
    const parentCreateWorkOrdersFromUser = {
      materialCode: this.parentObj.parent,
      locationCode: this.parentObj.location,
      qty: +this.bulkWorkOrdersPayloadCount,
    };
    const parentGetConfigDataForSpecificRow = {
      pendingQty: this.parentObj?.pendingQty ?? this.parentObj?.pending_wo_qty ?? 0,
      piCreatedToday: this.parentObj.piCreatedToday != null ? +this.parentObj.piCreatedToday : 0,
      piToBeCreated: this.parentObj.piToBeCreated != null ? +this.parentObj.piToBeCreated : +this.parentObj.suggested_wo
    }
    const material = parentCreateWorkOrdersFromUser.materialCode;
    const pendingQty = +parentCreateWorkOrdersFromUser.qty + parentGetConfigDataForSpecificRow.pendingQty;
    const piCreatedToday = +parentCreateWorkOrdersFromUser.qty + parentGetConfigDataForSpecificRow.piCreatedToday;
    const suggestedWorkOrderTextBox = parentGetConfigDataForSpecificRow.piToBeCreated - piCreatedToday;
    const userWorkOrders = suggestedWorkOrderTextBox > 0 ? suggestedWorkOrderTextBox : 0;
    if (this.data.parent === parentCreateWorkOrdersFromUser.materialCode) {
      this.data.userWorkOrders = userWorkOrders;
      this.data.piCreatedToday = piCreatedToday;
    }
    this.updateGridValue(material, 'pending_wo_qty', pendingQty);
  }

  handleCreateSkuWorkOrders() {
    this.loadParentGrid = false;
    this.skuTableFetched = false;
    this.poCode.setValue(null);
    this.deliveryDate.setValue(null);
    this.skuList = [];
    this.skuListHeaders = [];
    this.syncfusion.createSkuWorkOrders(this.bulkWorkOrdersPayload).pipe(switchMap(() =>
      this.syncfusion.getSkuList(this.selectedDataObject.parent, this.selectedDataObject.location))).subscribe({
        next: (response: any) => {
          // this.syncfusion.setReload(true);
          this.loadParentGrid = true;
          this.skuList = [...response];
          this.skuListHeaders = [
            {
              "field": "sku",
              "headerText": "Material",
              "allowFiltering": false,
              "width": "180",
            },
            {
              "field": "size",
              "headerText": "Size",
              "allowFiltering": false,
              "width": "160",
            },
            {
              "field": "suggested_wo",
              "headerText": "Suggested Work Order",
              "allowFiltering": false,
              "width": "160",
            },
            {
              "field": "createWorkOrder",
              "headerText": "Create Work Order",
              "allowFiltering": false,
              "width": "160"
            },
            {
              "field": "colour",
              "headerText": "Colour",
              "allowFiltering": false,
              "width": "160"
            },
          ];
          this.workOrderData = {};

          this.skuList.forEach(item => {
            if (item.sku) {
              this.workOrderData[item.sku] = item.suggested_wo;
              this.workOrderData[item.sku + '_fullData'] = { ...item };
            }
          });
          this.skuTableFetched = true;
          this.snack.open("Created Successfully", "close", {
            duration: 4000,
            horizontalPosition: "center",
            verticalPosition: "top",
          });
          delete this.createWorkOrdersFromUser;
        },
        error: (error) => {
          this.snack.open("Error while creating work orders", "close", {
            duration: 4000,
            horizontalPosition: "center",
            verticalPosition: "top",
          });
        }
      });
    this.dialogVisible = false;
  }
  saveWorkOrders() {
    if (this.deliveryDate.invalid || this.poCode.invalid) {
      this.snack.open('Please select a valid delivery date and PO code', "close", {
        duration: 4000,
        horizontalPosition: "center",
        verticalPosition: "top",
      });;
      return;
    }
    this.bulkWorkOrdersPayload = [];
    this.excessWorkOrderDetails = {};
    for (const sku of Object.keys(this.workOrderData)) {
      if (!this.workOrderData[sku] || sku.includes('_fullData')) {
        continue;
      }
      const data: any = this.workOrderData[sku + '_fullData'] || {};
      const noNeedPopUP = data.suggested_wo >= this.workOrderData[sku];
      const quantity = this.workOrderData[sku];
      const workOrder = {
        materialCode: data.sku,
        locationCode: data.locationCode || data.location,
        qty: +quantity,
        poCode: this.poCode.value,
        estimatedDeliveryDate: this.deliveryDate.value.toLocaleDateString('en-CA')
      };

      this.bulkWorkOrdersPayload.push(workOrder);

      this.createWorkOrdersFromUser = {
        materialCode: data.materialCode || data.sku,
        locationCode: data.locationCode || data.location,
        qty: +quantity,
      };
      if (!noNeedPopUP && workOrder.qty > 0) {
        this.excessWorkOrderDetails[data.sku] = workOrder.qty - (+data.suggested_wo);
      }
    }
    if (Object.keys(this.excessWorkOrderDetails).length > 0) {
      this.excessWorkOrderKeys = Object.keys(this.excessWorkOrderDetails);
      this.dialogVisible = true;
    } else {
      if (this.bulkWorkOrdersPayload.length > 0) {
        this.handleCreateSkuWorkOrders();
        this.bulkWorkOrdersPayloadCount = this.bulkWorkOrdersPayload.reduce((sum, order) => sum + order.qty, 0);
      }
    }
  }
  determineWorkOrderAction() {
    if (this.reportName === 'Brandstudio_Replenishment') {
      this.handleCreateSkuWorkOrders();
    } else {
      this.handleCreateWorkOrders();
    }
  }

  showBOMStatus(data) {
    this.bomDialogVisible = true;
    this.selected_bomdata = data;
  }
  showCreateWODialog(data) {
    // if (this.grid) {
    //   var position = this.grid.element.querySelectorAll('.e-movablecontent')[0].scrollLeft || 0;
    //   this.selectedIndex = +data.index;
    //   window.localStorage.setItem("selectedRowIndex", this.selectedIndex);
    //   this.dataSharingService.updatePosition(position);
    // }
    this.parentObj = data;
    this.skuTableFetched = false;
    this.selectedDataObject = data;
    this.syncfusion.getSkuList(data.parent, data.location).subscribe((response: any) => {
      this.skuList = response;
      // this.skuListHeaders = [
      //   {
      //     "field": "sku",
      //     "headerText": "Material",
      //     "allowFiltering": false,
      //     "width": "180",
      //   },
      //   {
      //     "field": "size",
      //     "headerText": "Size",
      //     "allowFiltering": false,
      //     "width": "160",
      //   },
      //   {
      //     "field": "suggested_wo",
      //     "headerText": "Suggested Work Order",
      //     "allowFiltering": false,
      //     "width": "160",
      //   },
      //   {
      //     "field": "createWorkOrder",
      //     "headerText": "Create Work Order",
      //     "allowFiltering": false,
      //     "width": "160"
      //   },
      //   {
      //     "field": "colour",
      //     "headerText": "Colour",
      //     "allowFiltering": false,
      //     "width": "160"
      //   },
      // ];
      this.workOrderData = {};
      this.skuList.forEach(item => {
        if (item.sku) {
          this.workOrderData[item.sku] = item.suggested_wo;
          this.workOrderData[item.sku + '_fullData'] = { ...item };
        }
      });
      this.skuTableFetched = true;
      this.createWODialogVisible = true;
    });
  }
  updateWorkOrderData(data: any, value: any) {
    if (data?.sku) {
      if (!this.workOrderData[data.sku]) {
        this.workOrderData[data.sku] = value;
      }
      this.workOrderData[data.sku + '_fullData'] = { ...data };
    }
  }
}
